import vhCheck from "vh-check";
import Slider from "../components/Slider";
import ChineseSymbolsHandler from "./ChineseSymbolsHandler";

export default class Common {
  constructor() {
    window.addEventListener("resize", () => this.resize());
  }

  init() {
    this.updateVhCssVar();
    this.handleSliders();
    this.handleChineseSymbols();
    this.handleHeaderNav();
    this.handleHeaderNavScroll();
    this.handleEnquireBtnScroll();
    this.removeLoader();
  }

  updateVhCssVar() {
    const vhObj = vhCheck();
    const header = document.querySelector(".top-header");
    const footer = document.querySelector(".footer");

    if (header) {
      document.body.style.setProperty(
        "--header-height",
        `${header.offsetHeight}px`,
      );
    }

    if (footer) {
      document.body.style.setProperty(
        "--footer-height",
        `${footer.offsetHeight}px`,
      );
    }
  }

  handleSliders() {
    const sliders = document.querySelectorAll(".www-slider");
    if (sliders.length) {
      sliders.forEach((item, i) => {
        const slider = new Slider(item);
        slider.init();
      });
    }
  }

  handleChineseSymbols() {
    const chineseSymbolsHandler = new ChineseSymbolsHandler();
    chineseSymbolsHandler.checkPageForSymbols();
  }

  handleHeaderNav() {
    const nav = document.querySelector("header nav");
    if (!nav) return;

    const toggleBtn = nav.querySelector(".nav-btn");
    if (!toggleBtn) return;

    toggleBtn.addEventListener("click", () => {
      nav.classList.toggle("nav--expanded");

      // If nav expanded, always hide enquire button. If collapsed, re-run enquire update.
      const enquireBtn = document.querySelector(".btn-enquire");
      if (nav.classList.contains("nav--expanded")) {
        if (enquireBtn) enquireBtn.classList.add("btn--hidden");
      } else {
        // nav collapsed -> allow enquire button to show if appropriate
        if (typeof this._updateEnquireBtn === "function") {
          this._updateEnquireBtn();
        } else if (enquireBtn) {
          // fallback: run a simple position check
          const firstSection =
            document.querySelector("section") ||
            document.querySelector(".section-location");
          if (!firstSection) {
            enquireBtn.classList.add("btn--hidden");
          } else {
            const pastFirst = firstSection.getBoundingClientRect().bottom <= 0;
            if (pastFirst) enquireBtn.classList.remove("btn--hidden");
            else enquireBtn.classList.add("btn--hidden");
          }
        }
      }
    });

    const langBtn = nav.querySelector(".lang-icon");
    const langOptions = nav.querySelector(".lang-options");
    if (langBtn) {
      langBtn.addEventListener("mouseenter", () => {
        langBtn.classList.add("lang-icon--hidden");
        langOptions.classList.add("lang-options--expanded");
      });
    }
    if (langOptions) {
      langOptions.addEventListener("mouseleave", () => {
        langBtn.classList.remove("lang-icon--hidden");
        langOptions.classList.remove("lang-options--expanded");
      });
    }

    const langWrapperMobile = document.querySelector(".lang-wrapper.mobile");
    const langBtnMobile = langWrapperMobile?.querySelector(".lang-icon");
    const langOptionsMobile = langWrapperMobile?.querySelector(".lang-options");
    if (langBtnMobile && langOptionsMobile) {
      langBtnMobile.addEventListener("click", () => {
        langOptionsMobile.classList.add("lang-options--expanded");
      });

      document.addEventListener("click", (event) => {
        if (!langWrapperMobile.contains(event.target)) {
          langOptionsMobile.classList.remove("lang-options--expanded");
        }
      });
    }
  }

  handleHeaderNavScroll() {
    const nav = document.querySelector("header nav");
    // const enquireBtn = document.querySelector(".btn-enquire");
    if (!nav /* || !enquireBtn */) return;

    let lastScrollY = window.scrollY || 0;
    let ticking = false;
    const threshold = 8;

    const onScroll = () => {
      const currentY = window.scrollY || 0;
      if (Math.abs(currentY - lastScrollY) < threshold) return;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (nav.classList.contains("nav--expanded")) {
            // if nav is expanded, do not hide it
            lastScrollY = currentY;
            ticking = false;
            return;
          }
          if (currentY > lastScrollY && currentY > 50) {
            // scrolling down -> hide nav
            nav.classList.add("nav--hidden");
            // enquireBtn.classList.remove("btn--hidden");
          } else {
            // scrolling up -> show nav
            nav.classList.remove("nav--hidden");
            // enquireBtn.classList.add("btn--hidden");
          }

          lastScrollY = currentY;
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
  }

  handleEnquireBtnScroll() {
    const enquireBtn = document.querySelector(".btn-enquire");
    if (!enquireBtn) return;

    const firstSection =
      document.querySelector("section") ||
      document.querySelector(".section-location");
    const footer =
      document.querySelector("footer") || document.querySelector(".footer");
    const nav = document.querySelector("header nav");

    let footerVisible = false;

    if (footer && "IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            footerVisible = entry.isIntersecting;
            update();
          });
        },
        { threshold: 0 },
      );
      io.observe(footer);
    }

    const update = () => {
      // if nav is expanded, always hide enquire button
      if (nav && nav.classList.contains("nav--expanded")) {
        enquireBtn.classList.add("btn--hidden");
        return;
      }
      if (footerVisible) {
        enquireBtn.classList.add("btn--hidden");
        return;
      }

      if (!firstSection) {
        enquireBtn.classList.add("btn--hidden");
        return;
      }

      const pastFirst =
        firstSection.getBoundingClientRect().bottom <= window.innerHeight / 2;
      if (pastFirst) {
        enquireBtn.classList.remove("btn--hidden");
      } else {
        enquireBtn.classList.add("btn--hidden");
      }
    };

    // expose update so header nav toggle can call it
    this._updateEnquireBtn = update;

    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          update();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    // initial check
    update();
  }

  removeLoader() {
    const loader = document.querySelector(".loader");
    if (loader) {
      loader.classList.add("fade-out");
      setTimeout(() => {
        loader.remove();
      }, 1200);
    }
  }

  resize() {
    this.updateVhCssVar();
  }
}
